import { createContext } from "react";

const NodeDeleteContext = createContext();

export default NodeDeleteContext;
